import React from 'react'
import { numberWithCommas } from '../../helpers/helpers'
import { FormattedData } from '../../types'
import {
    DotIcon,
    StyledDoseItem,
    StyledDoseRow,
    StyledSource,
    StyledTitle,
    StyledTitleWrap,
    StyledVaxBar,
    StyledVaxBarIndicator,
} from './JabTracker.styled'
export function WAVaccinationBar({
    data,
    type,
    isLoading,
}: {
    data: FormattedData
    type?: 'large' | 'small'
    isLoading: boolean
}) {
    const firstDoseCount = data.WA.vaccine.firstDose.count
    const secondDoseCount = data.WA.vaccine.secondDose.count
    const unvaxxedCount = numberWithCommas(data.WA.vaccine.unvaxinated.count)
    const firstDoseOnlyCount = numberWithCommas(
        firstDoseCount - secondDoseCount,
    )
    const firstAndSecondDoseCount = numberWithCommas(secondDoseCount)

    const firstDosePercentage = data.WA.vaccine.firstDose.percent
    const secondDosePercentage = data.WA.vaccine.secondDose.percent
    const unvaxxedPercentage = data.WA.vaccine.unvaxinated.percent

    const firstDoseOnlyPercentage = firstDosePercentage - secondDosePercentage
    const firstAndSecondDosePercentage = secondDosePercentage
    const barTransition = {
        ease: 'easeOut',
        duration: 1,
    }
    return (
        <>
            <StyledTitleWrap type={type}>
                <StyledTitle>WA vaccinations</StyledTitle>
            </StyledTitleWrap>
            <StyledVaxBar type={type}>
                <StyledVaxBarIndicator
                    animate={{ width: `${firstDoseOnlyPercentage}%` }}
                    transition={barTransition}
                >
                    {firstDoseOnlyPercentage}%
                </StyledVaxBarIndicator>
                <StyledVaxBarIndicator
                    animate={{ width: `${firstAndSecondDosePercentage}%` }}
                    transition={barTransition}
                >
                    {firstAndSecondDosePercentage}%
                </StyledVaxBarIndicator>
                <StyledVaxBarIndicator
                    animate={{ width: `${unvaxxedPercentage}%` }}
                    transition={barTransition}
                >
                    {unvaxxedPercentage}%
                </StyledVaxBarIndicator>
            </StyledVaxBar>
            <StyledDoseRow type={type}>
                <StyledDoseItem>
                    <DotIcon color="black">
                        <span></span>
                    </DotIcon>
                    <h6>
                        1st dose <br /> {firstDoseOnlyCount}
                    </h6>
                </StyledDoseItem>
                <StyledDoseItem>
                    <DotIcon color="blue">
                        <span></span>
                    </DotIcon>
                    <h6>
                        1st & 2nd dose <br /> {firstAndSecondDoseCount}
                    </h6>
                </StyledDoseItem>
                <StyledDoseItem>
                    <DotIcon color="white">
                        <span></span>
                    </DotIcon>
                    <h6>
                        Unvaccinated <br /> {unvaxxedCount}
                    </h6>
                </StyledDoseItem>
            </StyledDoseRow>
            <StyledSource>
                Source:
                <a href="https://covidlive.com.au">covidlive.com.au</a>
            </StyledSource>
        </>
    )
}
